<template>
  <BaseForm :model="formData" @loading="handleLoading">
    <FormHeader :title="_e('header_title')" :back-url="_e('header_back_url')" :image="_e('form_header_image')"></FormHeader>

    <FormBody>
      <h3 class="form-sec-title col--wide">{{ _e('title_basic_data', 'Dados Pessoais') }}</h3>

      <BasicInput type="text" required v-model="model.profile_url" class="col--wide"
        :label="_e('label_profile_link', 'Link do Perfil')"
        :placeholder="_e('ph_profile_link', 'http://')">
      </BasicInput>

      <BasicInput type="text" required v-model="model.nome" class="col--wide"
        :label="_e('label_name', 'Nome Completo')"
        :placeholder="_e('ph_name', 'Ex.: Carlos Almeida')">
      </BasicInput>

      <BasicInput type="email" required v-model="model.email" class="col--wide col--md-6"
        :label="_e('label_email', 'Email')"
        :placeholder="_e('ph_email', 'Ex.: carlos@email.com')">
        <template #prefix>
          <Icons name="mail" />
        </template>
      </BasicInput>

      <BasicInput type="text" required v-model="model.telefone" class="col--wide col--md-6"
        :label="_e('label_phone', 'Whatsapp')"
        :placeholder="_e('ph_phone', '+55 (00) 00000-0000')"
        :mask="['(##) #####-####', '(##) ####-####']">
        <template #prefix>
          <Icons name="phone" />
        </template>
      </BasicInput>

      <BasicInput type="text" required v-model="model.cpf" class="col--wide col--md-6"
        :label="_e('label_cpf', 'CPF')"
        :placeholder="_e('ph_cpf', '000.000.000-00')"
        :mask="'###.###.###-##'">
      </BasicInput>

      <BasicInput type="text" required v-model="model.birth" class="col--wide col--md-6"
        :label="_e('label_birth', 'Aniversário')"
        :placeholder="_e('ph_birth', 'dd/mm/aaaa')"
        :mask="'##/##/####'">
      </BasicInput>

      <DropdownInput required v-model="model.content" class="col--wide"
        :label="_e('label_content', 'Tipo de conteúdo')"
        :placeholder="_e('ph_content', 'Selecione')"
        :options="contentOptions">
      </DropdownInput>

      <FileInput class="col--wide col--md-6"
          :label="_e('label_midia', 'Anexar Mídia KIT')"
          :placeholder="_e('ph_midia', 'Selecionar Arquivo')"
          v-model="model.midia"></FileInput>

      <div class="col--wide">
        <CheckInput :options="termsConditions" v-model="model.terms" :required="true"></CheckInput>
      </div>

      <div class="col--wide col--md-5 col--jss">
        <VueTurnstile :site-key="config.TURNSTILE_KEY" v-model="token" theme="light"></VueTurnstile>
      </div>

      <div class="col--wide col--md-7 col--md-jse col--asc">
        <SubmitButton :is-loading="isLoading">{{ _e('form_submit', 'Enviar') }}</SubmitButton>
      </div>
    </FormBody>
  </BaseForm>
</template>

<script setup>
import { ref, computed, reactive } from 'vue';
import { _e } from '../helpers/l10n';
import config from '../helpers/config';

import VueTurnstile from 'vue-turnstile';

import BasicInput from '../components/form/inputs/BaseInput.vue';
import DropdownInput from '../components/form/inputs/DropdownInput.vue';
import FileInput from '../components/form/inputs/FileInput.vue';
import CheckInput from '../components/form/inputs/CheckInput.vue';
import BaseForm from '../components/form/BaseForm.vue';
import SubmitButton from '../components/form/SubmitButton.vue';
import Icons from '../components/icons/Icons.vue';
import FormHeader from '../components/sections/FormHeader.vue';
import FormBody from '../components/sections/FormBody.vue';


const termsConditions = _e('termos_condicoes');

const contentOptions = _e('content_options');

const token = ref('');
const isLoading = ref(false);

const model = reactive({
  profile_url: '',
  nome: '',
  email: '',
  telefone: '',
  cpf: '',
  birth: '',
  content: '',
  midia: [],
  terms: false,
});

function handleLoading(isFormLoading) {
  isLoading.value = isFormLoading;
}

const formData = computed(() => {
  const formData = new FormData();
    formData.append('profile_url', model.profile_url);
    formData.append('nome', model.nome);
    formData.append('email', model.email);
    formData.append('telefone', model.telefone);
    formData.append('cpf', model.cpf);
    formData.append('birth', model.birth);
    formData.append('content', model.content);
    formData.append('midia', model.midia);
    formData.append('terms', model.terms);
    formData.append('cf_token', token.value);

  return formData;
});
</script>
